/*jslint passfail: true*/
/*global $, fontsLoaded, console, counter*/
var resize_timer, init, gallery, checkFonts, slider_main, slider_obj, wykladowcy_modal, smooth_scroll, top_button, parallax, count;

init = function () {
    "use strict";
    parallax();
    count();
};

$(function () {
    "use strict";
    checkFonts();
});

checkFonts = function () {
    "use strict";
    if (!fontsLoaded) {
        setTimeout(function () { checkFonts(); }, 50);
        return;
    }
    init();
};

gallery = function () {
    "use strict";
    $('.gallery').photobox('a', {time: 0});
};


slider_main = function (el) {
    "use strict";
};

wykladowcy_modal = function () {
    "use strict";
};

smooth_scroll = function () {
    "use strict";
};

top_button = function () {
    "use strict";
};

parallax = function () {
    "use strict";
    $.parallaxify({
        // enable parallax effect for horizontal, vertical or both directions
        horizontalParallax: true,
        verticalParallax: true,

        // enable or disable parallax effect for elements or backgrounds
        parallaxBackgrounds: true,
        parallaxElements: true,

        // set which positioning property is to be used
        // options include 'position' or 'transform' using css transformations
        positionProperty: 'position',

        // enable for responsive layouts
        // (upon orientation changes or window resizing element positions are reevaluated
        responsive: true,

        // enable or disable mouse or gyroscope data as input for the plugin
        useMouseMove: true,
        useGyroscope: true,

        // use a Low Pass Filter to smooth sensor readings (1 = no filter)
        alphaFilter: 0.9,

        // set which motion type algorithm is to be used
        // options include 'natural', 'linear', 'gaussian', or 'performance'
        motionType: 'natural',
        mouseMotionType: 'gaussian',

        // define which sensor input has priority over the other
        // options are either 'mouse' or 'gyroscope'
        inputPriority: 'mouse',

        // define the delta angle (0 < motionAngle < 90) 
        // that is used to render max parallax in this direction
        motionAngleX: 80,
        motionAngleY: 80,

        // enable of adjustment of base position (using a Low Pass Filter)
        // (adapting to device usage while plugin is running)
        adjustBasePosition: true,
        // alpha for Low Pass Filter used to adjust average position
        alphaPosition: 0.05
    });
};

count = function() {
    $('.counter-value').numerator({
        toValue: counter,
        onStep: function(now, fx){
//            console.log('The current value is: ' + now);
            var tmp = parseInt(now).toString();
            while(tmp.length < 5) {
                tmp = "0"+tmp;
            }
//            console.log(tmp);
            $('.licznik .el:nth(0)').html(tmp[0]);
            $('.licznik .el:nth(1)').html(tmp[1]);
            $('.licznik .el:nth(2)').html(tmp[2]);
            $('.licznik .el:nth(3)').html(tmp[3]);
            $('.licznik .el:nth(4)').html(tmp[4]);
        },
        easing: 'easeOutQuint',
        duration: 5000
    });
}